import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleDown, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import Typed from 'react-typed';
import axios from 'axios';
import Skeleton from '../../components/skeleton/Skeleton';
import { API_ENDPOINTS } from '../../utils/config';

const BannerSection = () => {
    const [isLoading, setIsLoading] = useState(true);  
    const [banners, setBanners] = useState([]); 

    const fetchBanners = useCallback( async () => {
        setIsLoading( true );
        try {
            const response = await axios.get( API_ENDPOINTS.BANNER_ENDPOINT, {
                headers:{ 'Content-type': 'application/json; charset=UTF-8' }
            })
            setBanners( response.data || [] );
        } catch (error) {
            console.error( 'Failed to fetch banners:', error );
            setBanners( [] );
        } finally {
            setIsLoading( false );
        }
    }, [] );

    useEffect( () => {
        fetchBanners();
        // eslint-disable-next-line	
    },[fetchBanners] )

    if ( isLoading ) {
        return (
            <section id="home" className="bg-primary d-flex fullscreen-with-header position-relative">
                <Skeleton type="slider" />
            </section>
        );
    }

    if ( !banners.length ) {
        return (
            <section id="home" className="bg-primary d-flex fullscreen-with-header position-relative">
                <Container className="my-auto py-5 text-center text-white">
                    <p>No banner data available.</p>
                </Container>
            </section>
        );
    }

    return (
        <section id="home" className="bg-primary d-flex position-relative">
            {banners.map(({ id, title, keywords, excerpt, button_link, button_text, link_url, link_text, featured_image }) => (
                <Container className="my-auto py-5" key={id}>
                    <Row className="py-4">
                    <Col
                        lg={6}
                        sm={12}
                        className="text-center text-lg-start align-self-center order-1 order-lg-0"
                    >
                        <h1 className="text-8 fw-300 mb-0 text-blue">{title}</h1>
                        {keywords && keywords.length > 0 && (
                        <Typed
                            className="text-18 fw-600 text-uppercase mb-0 ms-n1 text-primary"
                            strings={keywords}
                            typeSpeed={50}
                            backSpeed={50}
                            loop
                        />
                        )}
                        <p className="text-4 text-muted">{excerpt}</p>
                        {button_link && button_text && (
                        <Link to={button_link} className="btn btn-green rounded-2 smooth-scroll text-white mt-3 me-3">
                            {button_text}
                        </Link>
                        )}
                        {link_url && link_text && (
                        <Link to={link_url} className="btn btn-link text-decoration-none smooth-scroll mt-3">
                            {link_text}
                            <span className="text-4 ms-2">
                            <FontAwesomeIcon icon={faArrowCircleDown} />
                            </span>
                        </Link>
                        )}
                    </Col>
                    <Col
                        lg={6}
                        sm={12}
                        className="text-center align-self-center mb-4 mb-lg-0 order-0 order-lg-1"
                    >
                        <div className="bg-light rounded-pill d-inline-block p-3 wow shadow-lg zoomIn">
                        <img
                            className="img-fluid rounded-pill d-block"
                            src={featured_image}
                            alt={title}
                            title={title}
                            loading="lazy"
                            decoding="async"
                        />
                        </div>
                    </Col>
                    </Row>
                </Container>
            ))}

            <Link to="/about-me" className="scroll-down-arrow text-dark smooth-scroll" aria-label="Scroll down to About Me section">
                <span className="animated">
                    <FontAwesomeIcon icon={faArrowDown} />
                </span>
            </Link>
        </section>
    );
};

export default BannerSection